import React from "react";
import { useLang } from "../LangContext";
import { IMAGES } from "../i18n";

export default function Impact() {
    const { t } = useLang();
    return (
        <section data-testid="impact-section" id="results" className="relative py-24 md:py-32 px-6 md:px-12 overflow-hidden">
            <div
                className="absolute inset-0 bg-cover bg-center opacity-30"
                style={{ backgroundImage: `url(${IMAGES.youth})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-transparent" />

            <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div>
                    <span className="text-xs font-mono uppercase tracking-[0.3em] text-volt">— {t.impact.label}</span>
                    <h2 className="font-graffiti text-4xl md:text-5xl lg:text-6xl tracking-tight mt-6 text-white leading-[0.95]">
                        {t.impact.title}
                    </h2>
                    <p className="mt-8 text-zinc-300 text-lg leading-relaxed max-w-xl">{t.impact.body}</p>
                </div>
                <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10">
                    {[
                        { v: "41/41", l: "School year completed" },
                        { v: "100%", l: "Stayed in club" },
                        { v: "3", l: "Year mentor commitment" },
                        { v: "5+", l: "Partner clubs" },
                    ].map((kpi, i) => (
                        <div key={i} className="bg-inksurface p-8">
                            <div className="font-display font-black text-4xl md:text-5xl text-volt leading-none">{kpi.v}</div>
                            <div className="mt-3 text-xs text-zinc-400 uppercase tracking-wider">{kpi.l}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
